module.exports = __webpack_public_path__ + "img/visual-03.f584b6eb.png";